import * as React from 'react';
import Slider from 'rc-slider';
import * as PropTypes from 'prop-types';
import { UserStore } from '@reverbdotcom/discovery-ui';

class BumpBidSlider extends React.Component {
  bidTierSteps() {
    const marks = {};
    marks[0.0] = I18n.t('js.bump.noBid');
    this.props.bidTiers.forEach((tier) => {
      const bidTier = parseFloat(tier[1]);
      if (UserStore.isExperimentEnabled('bump_reduce_tier_labels')) {
        marks[bidTier] = this.buildTierMark(tier);
      } else {
        marks[bidTier] = tier[0];
      }
    });
    return marks;
  }

  buildTierMark(tier) {
    const displayBids = ['0.01', '0.02', '0.03', '0.04', '0.05'];
    if (displayBids.indexOf(tier[1]) !== -1) {
      return {
        label: tier[0],
        style: {
          fontWeight: 'bold',
          color: '#000',
        },
      };
    }
    return '';

  }

  get maxBid() {
    return parseFloat(this.props.bidTiers[this.props.bidTiers.length - 1][1]);
  }

  get currentBid() {
    return this.props.bid ? parseFloat(this.props.bid) : 0.0;
  }

  get bidError() {
    return (!this.props.deleted && (this.props.error || this.bidEmpty));
  }

  get bidEmpty() {
    return this.props.bid === '' || this.props.bid === null || this.props.bid === undefined;
  }

  renderMessage() {
    const displaySuccess = !this.props.error && this.props.didBidChange;
    if (this.props.error) {
      return (
        <div className="bid-change__error">
          <h4 className="bid-change__error__text">
            {I18n.t('js.bump.errorBid')}
          </h4>
        </div>
      );
    } if (displaySuccess && this.props.deleted) {
      return (
        <div className="bid-change__success">
          <h4 className="bid-change__success__text">
            {I18n.t('js.bump.successBidDelete')}
          </h4>
          <button
            className="bid-change__dismiss"
            onClick={this.props.changeDismiss}
          />
        </div>
      );
    } if (displaySuccess) {
      return (
        <div className="bid-change__success">
          <h4 className="bid-change__success__text">
            {I18n.t('js.bump.successBid', { percent: (parseFloat(this.props.setBid) * 100).toFixed(1) })}
          </h4>
          <button
            className="bid-change__dismiss"
            onClick={this.props.changeDismiss}
          />
        </div>
      );
    }
    return null;
  }

  shouldRenderDeleteMessage() {
    return !this.props.error && this.props.deleted && this.currentBid === 0.0;
  }

  renderZeroBidNote() {
    if (!this.shouldRenderDeleteMessage()) { return null; }

    const deleteMessage = I18n.t('js.bump.deleteBidBumpV2');
    return <div className="size-90 mtb-1">{deleteMessage}</div>;
  }

  render() {
    if (this.bidError === true) {
      return (
        <div className="alert alert-warning">{I18n.t('js.bump.bidFetchError')}</div>
      );
    }
    return (
      <div>
        <div className="reverb-rc-slider">
          <Slider
            dots
            step={this.props.tierIncrement}
            marks={this.bidTierSteps()}
            min={0.0}
            max={this.maxBid}
            value={this.currentBid}
            onChange={newBid => this.props.onBidChange(newBid)}
            onAfterChange={newBid => this.props.updateBid(newBid)}
          />
        </div>
        <div className="bid-change">
          {this.renderMessage()}
        </div>
        {this.renderZeroBidNote()}
      </div>
    );
  }
}

BumpBidSlider.propTypes = {
  bidTiers: PropTypes.array.isRequired,
  tierIncrement: PropTypes.number.isRequired,
  bid: PropTypes.number,
  setBid: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  updateBid: PropTypes.func,
  onBidChange: PropTypes.func,
  error: PropTypes.bool,
  didBidChange: PropTypes.bool,
  deleted: PropTypes.bool,
  changeDismiss: PropTypes.func,
};

export default BumpBidSlider;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/bump_bid_slider.jsx